"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteContext = void 0;
const react_1 = require("react");
exports.AutocompleteContext = (0, react_1.createContext)({});
//# sourceMappingURL=autocomplete-context.js.map